import _ from 'lodash';
import { createScheduleTypes } from 'projectSpecific/sports/cnr/reducers/CreateSportsReducer';
import { useContext, useEffect, useReducer, useState } from 'react';
import { Label } from 'semantic-ui-react';
import { sidebarHandlers, sidebarInitialState, sidebarMenuTypes, sidebarReducer, sidebarSliderTypes } from '../../../../global/cnr/reducers/SidebarReducer';
import UiSaveButtons from '../../../../global/components/buttons/UiSaveButtons';
import DragDropper, { dragDropperTypes } from '../../../../global/dragNDrops/DragDropper';
import DragFramer from '../../../../global/dragNDrops/DragFramer';
import MenuSidebars from '../../../../global/sidebars/MenuSidebars';
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { sportsHelpers } from '../../cnr/reducers/reducerHelpers/sportsHelpers';
import { _teamNames, _teamNamesReplace } from '../../elements/standings/SectionStandings';
import { CreatePlayoffContext } from '../CreatePlayoff';
import { CreateSportsContext } from '../CreateSports';
import { getSectionColor } from '../sectionColors';

const sidebarType = 'createSeeds'

export const seedTypes = {
  playoff: 'playoff',
  tournament: 'tournament'
}

const CreateSeeds = (props) => {

  const { createScheduleType, seedType } = props

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_handlers } = sportsSeasonContext ?? {}

  // createSportsContext
  const createSportsContext = useContext(CreateSportsContext);
  const { createSports_state } = createSportsContext ?? {}
  const { teams_info } = createSports_state ?? {}
  const { selected: teams_selected } = teams_info ?? {}

  // createPlayoffContext
  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state, createPlayoff_handlers } = createPlayoffContext ?? {}
  const { seededTeams, playoff_info, playoffGroup } = createPlayoff_state ?? {}
  const { playoffLevelTeams, playoffLevel } = playoff_info ?? {}

  // sidebar
  const [sidebar_state, sidebar_dispatch] = useReducer(sidebarReducer, sidebarInitialState({ sidebarType, handlers: sportsSeason_handlers }));
  const sidebar_handlers = sidebarHandlers(sidebar_dispatch)
  const { sidebar_items, currents, dimmed } = sidebar_state ?? {}
  const { setInit } = sidebar_handlers ?? {}

  const { ms_playoffGroups } = sidebar_items ?? {}
  const { selected: selected_pg } = ms_playoffGroups ?? {}
  const { item: item_pg } = selected_pg ?? {}

  const _initProps = { sidebarSliderType: sidebarSliderTypes.labeled }

  const [levels, setLevels] = useState()

  const createSeededTeams = (teams) => {
    const _seededTeams = {}
    _.forEach(teams, (team, index) => {
      const { id, name, levels, sections, record } = team
      const { sectionRank } = record ?? {}
      _seededTeams[id] = {
        id: id,
        name: name,
        levels: levels,
        sections: sections,
        record: {
          ...record,
          sectionRank,
        },
        seed: index,
        position: index,
      }
    })
    console.log('_seededTeams', _seededTeams)
    return _seededTeams
  }

  useEffect(() => {
    if (playoffLevel) {
      setInit({ smt: sidebarMenuTypes.one, items: [playoffLevel], currents, as: 'playoffGroups', ..._initProps })
    } else if (levels) {
      setInit({ smt: sidebarMenuTypes.one, items: levels, currents, as: 'playoffGroups', ..._initProps })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [levels, playoffLevel]);

  useEffect(() => {
    if (teams_selected) {
      const _seededTeams = createSeededTeams(teams_selected)
      createPlayoff_handlers.handleUpdate_seededTeams(_seededTeams)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [teams_selected]);

  // once
  useEffect(() => {
    if (playoffLevelTeams) {
      setLevels(Object.keys(playoffLevelTeams).sort().reverse())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  useEffect(() => {
    if (playoffLevelTeams) {
      const _playoffLevelTeams = {}
      _.forEach(playoffLevelTeams, (_playoffGroup, pltk) => {
        const _playoffGroup_sorted = _.orderBy(_playoffGroup, ['owp'], ['desc']);
        _playoffLevelTeams[pltk] = _playoffGroup_sorted
      })
      createPlayoff_handlers.handleSet_playoffLevelTeams(_playoffLevelTeams)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  useEffect(() => {
    if (playoffLevelTeams && item_pg) {
      const _playoffGroup = playoffLevelTeams[item_pg]
      createPlayoff_handlers.handleSet_playoffGroup(item_pg, _playoffGroup)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [item_pg, playoffLevelTeams]);

  const handleSortTeams = (opts) => {
    const { sortBy } = opts
    const _playoffGroup = playoffLevelTeams[item_pg]
    let _teams_sorted;
    switch (sortBy) {
      case 'points':
        _teams_sorted = _.orderBy(_playoffGroup, ['record.ppm', 'record.owp', 'record.swp'], ['desc', 'desc', 'desc']);
        break;
      case 'owp':
        _teams_sorted = _.orderBy(_playoffGroup, ['owp'], ['desc']);
        break;
      default:
        _teams_sorted = _.orderBy(_playoffGroup, ['record.ppm', 'record.owp', 'record.swp'], ['desc', 'desc', 'desc']);
    }
    _.forEach(_teams_sorted, (t, index) => {
      t.seed = index + 1
      t.position = index
    })
    createPlayoff_handlers.handleSet_playoffGroup(item_pg, _teams_sorted)
  }


  const handleReorder = (items, groupInfo) => {
    if (seedType === seedTypes.playoff && playoffLevelTeams) {
      const plt = { ...playoffLevelTeams }
      _.forEach(items, (dataItem, index) => {
        dataItem.position = index
        dataItem.seed = index + 1
      })
      plt[item_pg] = items
      createPlayoff_handlers.handleAmmend_playoffSeededTeams(plt)
    } else if (seedType === seedTypes.tournament) {
      // Object.keys(sortedGroups).forEach(key => {
      //   const dataItems = sortedGroups[key].dataItems
      //   Object.keys(dataItems).forEach(k => {
      //     const dataItem = dataItems[k]
      //     // match seed and position
      //     dataItem.seed = dataItem.position
      //     newVld[dataItem.id] = dataItem
      //   })
      // })
      // createPlayoff_handlers.handleUpdate_seededTeams(newVld)
    }
  }
  // Michelle.ed.cook@gmail.com
  /** handles the sorting of teams in the levels and sections */
  const handleSorted = (sortedGroups) => {
    if (!sortedGroups) return;

    const newVld = {};

    if (seedType === seedTypes.playoff && playoffLevelTeams) {
      _.forEach(sortedGroups, (group) => {
        const dataItems = _.get(group, "dataItems", {});

        _.forEach(dataItems, (dataItem) => {
          dataItem.seed = dataItem.position;
          newVld[dataItem.id] = dataItem;
        });

        const plt = { ...playoffLevelTeams };
        plt[selected_pg.item] = _.sortBy(newVld, "seed");

        createPlayoff_handlers.handleAmmend_playoffSeededTeams(plt);
      });
    }
    else if (seedType === seedTypes.tournament) {
      _.forEach(sortedGroups, (group) => {
        const dataItems = _.get(group, "dataItems", {});

        _.forEach(dataItems, (dataItem) => {
          dataItem.seed = dataItem.position;
          newVld[dataItem.id] = dataItem;
        });
      });

      createPlayoff_handlers.handleUpdate_seededTeams(newVld);
    }
  };


  const lblSize = 'mini'

  // const numberLabel = (index, text) => <Label color={'grey'}>{indexLabel(index)}{text}</Label>
  // {indexLabel(index, badSeed)}
  // const numberLabelWith = (cn, index, text, section, sectionRank, badSeed) => <div className={cn}><div>{text}</div> {sectionRankLabel(section, sectionRank ? sectionRank : '-')} {sectionLabel(section)}</div>
  // const indexLabel = (index, badSeed) => <Label size={lblSize} color={badSeed ? getSectionColor(badSeed) : 'black'}>{index}</Label>
  // const sectionLabel = (section) => <Label size={lblSize} color={getSectionColor(section)}>{section}</Label>
  // const sectionRankLabel = (section, rank) => <Label size={lblSize} color={getSectionColor(section)}>{rank}</Label>

  // const btns_search = () => {
  //   const btns = []
  //   btns.push({ caption: 'Sort by Points', oc: handleSortTeams, color: 'blue', fl: true, icon: 'sort', opts: { sortBy: 'points' } })
  //   btns.push({ caption: 'Sort by OWP', oc: handleSortTeams, color: 'blue', fl: true, icon: 'sort', opts: { sortBy: 'owp' } })
  //   return btns
  // }

  // const seedFooter = () => {
  //   const _allBtns = btns_search()
  //   return <div className={'header-flex'}>
  //     <div className='flx2'>
  //       <div>
  //         <DropdownOptionsMenu menuButtons={_allBtns} caption={'Sort'} icon={'options'} color={'blue'} upward={true} />
  //       </div>
  //     </div>
  //   </div>
  // }

  const seedFooter = () => {
    const btns = []
    btns.push({ oc: copyToClipboard, caption: 'Copy', icon: 'copy' })
    return <UiSaveButtons others={btns} />

  }

  const teamName = (name) => {
    let _name = name
    for (let i = 0; i < _teamNames.length; i++) {
      if (name.includes(_teamNames[i])) {
        _name = name.replace(_teamNames[i], _teamNamesReplace[i]);
      }
    }
    return _name
  }

  const sorts = [
    { name: 'name', icon: 'sort alphabet down', sortProp: 'name' },
    { name: 'owp', icon: 'sort numeric down', sortProp: 'owp', sortOrder: 'desc' },
  ]

  /**
   * 
   * @param {*} groupInfo 
   * @returns <DragFramer/>
   */
  const dragFramer = (groupInfo) => <DragFramer
    axis={'y'}
    forSeeding={true}
    groupInfo={groupInfo}
    handleReorder={handleReorder}
    headerColor={'black'}
    sorts={sorts}
  />

  const menuMenuItems = (dataItems) => {
    const ds = []
    _.forEach(dataItems, (di, dik) => {
      const { name, seed, sections, owp } = di
      let cn = 'drag-number seed'
      const cs = getSectionColor(sections)
      ds.push(<div className={cn}>
        {name}
        <Label size='tiny' circular>
          {owp}
        </Label>
        <Label size='tiny' style={{ border: '1px solid ' + cs }}>
          {_.startCase(sections)}
        </Label>
      </div>)
    })
    return ds
  }

  const copyToClipboard = () => {
    const dataItems = _.sortBy(playoffGroup, 'seed')
    sportsHelpers.copyTeamDataToClipboard(dataItems, ['seed', 'name'])
  }

  const playoffGroupContainer = () => {
    const dndGroups = {}
    const dataItems = _.sortBy(playoffGroup, 'seed')
    const elements = menuMenuItems(dataItems)
    dndGroups['seeds'] = { elements, dataItems }
    const groupInfo = { group: dndGroups['seeds'], caption: `Seeds`, label: item_pg }
    return dragFramer(groupInfo)
  }

  const playoffGroupWrapper = () => <Wrapper
    content={playoffGroupContainer()}
    footer={seedFooter()}
    wrapperType={wrapperTypes.paddedFooter}
  />

  const seededGroupContainer = () => {
    const dndGroups = {}
    const dataItems = _.sortBy(seededTeams, 'seed')
    const elements = menuMenuItems(dataItems)
    dndGroups['seeds'] = { elements, dataItems }
    return <DragDropper
      dndType={dragDropperTypes.simple}
      handleSorted={handleSorted}
      groupChangeKey={'seeds'}
      allowSort={true}
      portalCn={'msmi four menu'}
    />
  }

  const menuSidebars = () => <MenuSidebars
    sidebarType={sidebarType}
    sidebar_items={sidebar_items}
    sidebar_handlers={sidebar_handlers}
    content={playoffGroup ? playoffGroupWrapper() : <div></div>}
    dimmed={dimmed}
  />

  if (playoffLevelTeams && levels && ms_playoffGroups && ms_playoffGroups.items) {
    if (createScheduleType === createScheduleTypes.playoff) {
      return playoffGroup ? playoffGroupWrapper() : <div></div>
    } else {
      return menuSidebars()
    }
  } else if (seededTeams && !playoffLevelTeams) {
    return seededGroupContainer()
  }

  return <div></div>

}

export default CreateSeeds